import { Box, Grid, Link, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import {
  TERMS_AND_CONDITIONS_LINK_YEARLY,
  VA_MONEY_BACK_GUARANTEE,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";

import styles from "../styles";

interface Props {
  isVaMoneyBack: boolean;
}

const VaCard = ({ isVaMoneyBack }: Props) => {
  const { plans } = useContext(SubscriptionContext);
  const trackTermsAndCondition = () => {
    trackEvent("Terms and Conditions for VA Plan Clicked", {
      source: "Onboarding Paywall",
    });
  };

  if (!plans) return <></>;
  return (
    <Box sx={[styles.card, { backgroundColor: "#151F16" }]}>
      <Box sx={[styles.chip, { backgroundColor: "purple.main" }]}>
        33x more likely to land a deal
      </Box>

      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs={6} container alignItems={"flex-end"}>
          <Typography component="div" sx={styles.planName} variant="h4">
            AI Virtual Assistant
          </Typography>
          <Typography>
            {" "}
            <Link
              href={
                isVaMoneyBack
                  ? VA_MONEY_BACK_GUARANTEE
                  : TERMS_AND_CONDITIONS_LINK_YEARLY
              }
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackTermsAndCondition}
              sx={{
                color: "purple.main",
                fontSize: 10,
                textDecoration: "underline",
                textDecorationColor: "purple.main",
              }}
            >
              {isVaMoneyBack ? "Money-Back" : ""} Terms & Conditions
            </Link>
          </Typography>
        </Grid>

        <Box>
          {" "}
          <Box sx={styles.startAtText}>
            Starts at <br />
          </Box>
          <Box sx={styles.priceText}>${plans[Plans.VA_YEARLY]?.price}/mo</Box>
        </Box>
      </Grid>
    </Box>
  );
};

export default VaCard;
